import type { TOC } from '@ember/component/template-only'
import { LayoutBlocksConfirmModal } from 'teacher-ui-client/components/layout-blocks/confirm-modal'
import { t } from 'ember-intl'

interface Args {
  visible: boolean
  cancel: () => unknown
  startRollover: () => unknown
  isSubmitting: boolean
}
interface Signature {
  Args: Args
}

export const RolloverStartPrompt: TOC<Signature> = <template>
  <LayoutBlocksConfirmModal
    @title={{t "manage.rollover.wizard.startPrompt.title"}}
    @showModal={{@visible}}
    @cancel={{@cancel}}
    @cancelButtonText={{t "cancel"}}
    @confirm={{@startRollover}}
    @confirmButtonText={{t "manage.rollover.wizard.startPrompt.submit"}}
    @isSubmitting={{@isSubmitting}}
  >
    <p class="m-6" data-test-rollover-start-prompt>
      {{t "manage.rollover.wizard.startPrompt.summary"}}
      <ul class="pt-3 pl-8">
        <li>- {{t "manage.rollover.wizard.startPrompt.actionOne"}}</li>
        <li>- {{t "manage.rollover.wizard.startPrompt.actionTwo"}}</li>
      </ul>
    </p>
  </LayoutBlocksConfirmModal>
</template>

export default RolloverStartPrompt
